import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { BrowserRouter as Router, Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { checkAuthRequest } from 'store/thunks/authThunk'
import Login from 'views/Auth/Login'
import Page404 from 'views/Page404'
import PageCreator from 'views/Pages/PageCreator'
import PageEditor from 'views/Pages/PageEditor'
import PageList from 'views/Pages/PageList'
import PageShow from 'views/Pages/PageShow'
import ProtectedRoute from './ProtectedRoute'
import PublicRoute from './PublicRoute'
import GlobalAnalytics from 'views/Analytics/GlobalAnalytics'
import PageAnalytics from 'views/Analytics/PageAnalytics'

/**
 * Componente que maneja las rutas de la aplicación.
 * @class
 */
const AppRouter = () => {
  const dispatch = useDispatch()
  const { usuario, verificando } = useSelector((state) => state.auth)

  /**
   * Hook useEffect que comprueba el estado de autenticación
   * del usuario al montar la aplicación.
   */
  useEffect(() => {
    dispatch(checkAuthRequest())
  }, [dispatch])

  // Renderiza la aplicación si ya se finalizó la verificación de autenticación
  if (!verificando) {
    return (
      <>
        <Router>
          <Routes>
            <Route path="/" element={<Outlet />}>
              {/* Rutas globales */}
              <Route path="/:url" element={<PageShow />} />
              <Route path="/404" element={<Page404 />} />

              {/* Rutas publicas */}
              <Route element={<PublicRoute isAuthenticated={!!usuario?.uid} />}>
                <Route path="admin/login" element={<Login />} />
              </Route>

              {/* Rutas protegidas */}
              <Route element={<ProtectedRoute isAuthenticated={!!usuario?.uid} />}>
                <Route path="pages" element={<PageList />} />
              </Route>

              <Route element={<ProtectedRoute isAuthenticated={!!usuario?.uid} />}>
                <Route path="pages/creator" element={<PageCreator />} />
              </Route>

              <Route element={<ProtectedRoute isAuthenticated={!!usuario?.uid} />}>
                <Route path="pages/:url/editor" element={<PageEditor />} />
              </Route>

              <Route element={<ProtectedRoute isAuthenticated={!!usuario?.uid} />}>
                <Route path="analytics/global" element={<GlobalAnalytics />} />
              </Route>

              <Route element={<ProtectedRoute isAuthenticated={!!usuario?.uid} />}>
                <Route path="analytics/pages/:url" element={<PageAnalytics />} />
              </Route>

              {/* Redirigir las demás rutas a /404 */}
              <Route path="/" element={<Navigate to="/404" />} />
              <Route path="*" element={<Navigate to="/404" />} />
            </Route>
          </Routes>
        </Router>
      </>
    )
  }
}

export default AppRouter
